{
  "version": 1,
  "asset_id": "aa14f6c5-2156-4155-be90-9eb76cf87d0b",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/aa14f6c5-2156-4155-be90-9eb76cf87d0b/rentals-hewescraft-700.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/aa14f6c5-2156-4155-be90-9eb76cf87d0b/rentals-hewescraft-700.jpg",
  "original_filename": "rentals-hewescraft-700.jpg",
  "size": 78285,
  "content_type": "image/jpeg",
  "created_at": "2026-07-03T03:49:14Z"
}
